<template>
  <div class="term">
    <app-header />
    <div class="main order-page">
      <div class="ui-box bank-transfer-box">
        <h3>银行转账</h3>
        <div class="ui-box-con">
          <h6>各软件产品购买汇款帐号</h6>
          <ul class="info-list">
            <li>
              <b>账 号:</b> {{payTransInfo.bankAccount}}
            </li>
            <li>
              <b>开户行:</b> {{payTransInfo.bankName}}
            </li>
            <li>
              <b>收款人:</b> {{payTransInfo.busName}}
            </li>
          </ul>

          <h6>银行汇款相关信息</h6>
          <ul class="info-list">
            <li>
              <b>汇款金额：</b> {{payTransInfo.transAmount | numFormat}}
              <span class="gray">(为了能及时对帐、快速开通，金额增加了1-99分的余数，银行汇款时请严格按照上述金额汇款)</span>
            </li>
            <li>
              <b>收款人全称：</b> {{payTransInfo.busName}}
            </li>
            <li>
              <b>收款人帐号：</b> {{payTransInfo.bankAccount}}
            </li>
            <li>
              <b>汇入行名称：</b> {{payTransInfo.bankName}}
            </li>
          </ul>
          <p>
            注：您只须按如下汇款单样式进行汇款(附言中一定要填写您的真实手机号及您的产品订单号)，
            <br />如有任何疑问欢迎致电我们：
            <b class="blue">021-20219997</b> 。
          </p>

          <h6>银行汇款单样例</h6>
          <p>
            “收款人全称、账号、汇入地点、汇入行名称”四项请按上述信息填写；
            <br />“汇款人全称、账号、汇出地点、汇出行名称”请详细填写您的个人信息；
            <br />“汇款金额”应为 {{payTransInfo.transAmount | numFormat}} 元人民币；
            <br />“附加信息及用途”请注明您的订单号 2000831 和您的联系电话。
          </p>
          <p>
            <img src="../../assets/images/pay/trans-sample-1.gif" />
          </p>
          <p>
            <img src="../../assets/images/pay/trans-sample-2.gif" />
          </p>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";

export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      busId: this.$route.params.busId,
      bankId: this.$route.params.bankId,
      payTransInfo: {}
    };
  },
  created() {
    this.getPayTransInfo();
  },
  methods: {
    getPayTransInfo() {
      var params = {
        id: this.orderId,
        busId: this.busId,
        bankId: this.bankId
      };
      this.$get("/pay/trans", params)
        .then(response => {
          if (response.code === 0) {
            this.payTransInfo = response.data;
          } else if (response.code != 100) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    }
  },
  components: {
    AppHeader,
    AppFooter
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/pay/PayTrans.vue